// src/components/Testimonials.js
import React from 'react';

const testimonials = [
  {
    quote: "Oolook is a game-changer. We've automated our entire content calendar, and our engagement has never been higher. It feels like we have a dedicated social media strategist on our team.",
    author: "Sarah Johnson",
    role: "Marketing Director at Innovate Inc.",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg"
  },
  {
    quote: "As a solo creator, I was drowning in tasks. Oolook's AI not only generates incredible content ideas but also frees me up to actually create. I can't imagine my workflow without it.",
    author: "Alex Martinez",
    role: "Content Creator & YouTuber",
    avatar: "https://randomuser.me/api/portraits/men/46.jpg"
  },
  {
    quote: "The analytics are incredibly insightful. We're no longer guessing what works. Oolook gives us clear, actionable data that has directly improved our campaign performance and ROI.",
    author: "Emily Chen",
    role: "Founder of a D2C Brand",
    avatar: "https://randomuser.me/api/portraits/women/47.jpg"
  }
];

const Testimonials = () => {
  return (
    <section className="py-24 sm:py-32 bg-dark-bg">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-xl text-center">
          <h2 className="text-lg font-semibold leading-8 tracking-tight bg-gradient-to-r from-dark-accent-start to-dark-accent-end bg-clip-text text-transparent">
            Testimonials
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
            We've helped thousands of teams grow faster
          </p>
        </div>
        <div className="mx-auto mt-16 flow-root max-w-2xl sm:mt-20 lg:mx-0 lg:max-w-none">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            {testimonials.map((testimonial) => (
              <div key={testimonial.author} className="p-8 bg-dark-card/40 rounded-2xl border border-white/10">
                <p className="text-base text-dark-text-secondary">"{testimonial.quote}"</p>
                <footer className="mt-6 flex items-center gap-x-4">
                  <img className="h-10 w-10 rounded-full bg-gray-50" src={testimonial.avatar} alt={testimonial.author} />
                  <div>
                    <div className="font-semibold text-dark-text-primary">{testimonial.author}</div>
                    <div className="text-sm text-dark-text-secondary/70">{testimonial.role}</div>
                  </div>
                </footer>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;